/**
 * @deprecated Moved to `@post-office/universal-contracts/shared-request-middleware-context/context-types`.
 * Import from there instead. This shim will be removed in a future cleanup.
 */
export type {
	EligibleMessage,
	EnrichedAttributes,
	MessageCategory,
	MessageCreationType,
	PreloadedMessageInput,
	ReadStatus,
	RerankingOptions,
} from '@post-office/universal-contracts/shared-request-middleware-context/context-types';

/**
 * Runtime enum for SortingMethod — kept here in `shared-contracts` for backwards
 * compatibility with consumers that use `SortingMethod.DEFAULT_ML_RECOMMENDATIONS`
 * as a value. Migrate callers to use the string literal
 * `'DEFAULT_ML_RECOMMENDATIONS'` directly, then remove this enum.
 *
 * @deprecated Use the string literal `'DEFAULT_ML_RECOMMENDATIONS'` or import
 * `type SortingMethod` from `@post-office/universal-contracts` instead.
 */
export enum SortingMethod {
	DEFAULT_ML_RECOMMENDATIONS = 'DEFAULT_ML_RECOMMENDATIONS',
}

type MicrosEnvType = 'local' | 'staging' | 'prod';

type PostOfficeMicrosEnv =
	| 'local'
	| 'stg-east'
	| 'stg-eucentral'
	| 'stg-apse2'
	| 'stg-fedm-east'
	| 'stg-gcentral'
	| 'prod-east'
	| 'prod-west2'
	| 'prod-euwest'
	| 'prod-euwest2'
	| 'prod-eucentral'
	| 'prod-eucentral2'
	| 'prod-apne'
	| 'prod-apne2'
	| 'prod-apse'
	| 'prod-apse2'
	| 'prod-apsouth'
	| 'prod-cacentral'
	| 'prod-fedm-east'
	| 'prod-gcentral';

type MicrosPerimeter = 'commercial' | 'fedramp-moderate';

export type MicrosConfig = {
	instanceId: string;
	group: string;
	// AWS region of the service's AWS-backed dependencies (SES, SQS, DynamoDB, ...).
	awsRegion: string;
	// The region this instance actually runs in (AWS or GCP), derived from MICROS_ENV
	// (e.g. 'us-east-1', 'us-central1'). Use for geo/locale logic like timezone.
	// On AWS this equals awsRegion; on GCP it diverges (e.g. us-central1).
	deploymentRegion: string;
	envType: MicrosEnvType;
	env: PostOfficeMicrosEnv;
	perimeter: MicrosPerimeter;
	serviceId: string;
	serviceDomainName: string;
	whitelistProxyHost: string;
	// Currently MICROS_IC will only be present in IC environments
	ic?: string;
	// We only set this up in IC environments
	icBaseDomain?: string;
	// We only set this up in IC environments
	icRMLAssetsBaseUrl?: string;
	awsAccountId?: string;
};

export type RemoteExecutionConfig = {
	allowRemoteExecution: boolean;
};

export type Config = {
	micros: MicrosConfig;
	remoteExecution: RemoteExecutionConfig;
};
